import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormattedHTMLMessage } from '@bibliocommons/react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Link, SecondaryLink } from '@bibliocommons/base-links';
import { bibShape } from '@bibliocommons/bc-prop-types';

import './DigitalContentInfo.scss';

function renderFormatsInfo(formats) {
  if (formats && formats.size > 0) {
    return (
      <div>
        <FormattedMessage id="digital_formats_label">
          {message => <div className="formats-label">{message}</div>}
        </FormattedMessage>
        {formats.map((format, index) => (
          <span className="digital-format" key={format.get('name')}>
            <FormattedHTMLMessage id={`digiformat_${format.get('name').toLowerCase()}`} />
            {index < formats.size - 1 ? ', ' : ''}
          </span>
        ))}
      </div>
    );
  }

  return null;
}

function renderDigitalVendorInfo(bib) {
  const policy = bib.get('policy');
  const quickStartUrl = policy.getIn(['materialPolicy', 'quickStartUrl']);
  const helpUrl = policy.getIn(['materialPolicy', 'helpUrl']);

  if (!quickStartUrl || !helpUrl) {
    return null;
  }

  const vendorLink = (
    <Link target="_blank" className="vendor-link" dataKey="vendor-link" href={quickStartUrl}>
      <FormattedMessage id={`digital_service_type_${policy.get('provider').toLowerCase()}`} />
    </Link>
  );

  const digitalHelpLink = (
    <SecondaryLink target="_blank" dataKey="digital-help-link" href={helpUrl}>
      <FormattedMessage id="help_with_digital_content" />
    </SecondaryLink>
  );

  return (
    <div className="digital-vendor-info">
      <div className="digital-content-provider">
        <FormattedMessage id="digital_content_provider" values={{ link: vendorLink }} />
      </div>
      {digitalHelpLink}
    </div>
  );
}

// This component block will be displayed for digital bibs
export default function DigitalContentInfo({ bib, digitalFormats }) {
  if (bib.getIn(['policy', 'materialType']) !== 'DIGITAL') {
    return null;
  }

  const formatsInfo = renderFormatsInfo(digitalFormats);
  const vendorInfo = renderDigitalVendorInfo(bib);

  return formatsInfo || vendorInfo ? (
    <div className="cp-digital-content-info">
      {formatsInfo}
      {vendorInfo}
    </div>
  ) : null;
}

DigitalContentInfo.propTypes = {
  bib: bibShape.isRequired,
  digitalFormats: ImmutablePropTypes.list
};
